<style scoped>
.tracking-bullet {
  position: absolute;
  background-color: #999999;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  z-index: 10;
  display: flex;
}

.tracking-bullet svg {
  margin: auto;
}

.finished .tracking-bullet {
  background-color: #007bff;
}

.active .tracking-bullet::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  background-color: #34ff26;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  z-index: 100;
}

.tracking-container:not(:last-child) .tracking-item::after {
  content: '';
  position: absolute;
  left: 0px;
  top: 0px;
  border-left: 6px solid #999999;
  height: calc(100% + 1rem);
  z-index: 0;
}

.tracking-container.finished .tracking-item::after {
  border-left: 6px solid #007bff;
  margin-top: 5px;
}

.tracking-container.active .tracking-item::after {
  border-left: 6px solid #999999;
}

.tracking-item {
  position: relative;
  margin-left: 12px;
  padding-left: 24px;
  min-height: 100px;
}

.tracking-item p {
  color: #999999;
}

.finished .tracking-item p {
  color: #555555;
}

.last-tracking-item {
  margin-left: 12px;
  padding-left: 26px;
}

.tracking-title {
  margin: 0px;
  font-weight: bold;
  font-size: large;
}
</style>

<template>
  <div>
    <nav-bar />

    <div class="main">
      <page-header
        title="Tracking Permohonan"
        subtitle="Silahkan gunakan nomor permohonan dari OSS untuk mencari permohonan Anda"
      />
      <section class="review-section ptb-100">
        <div class="container">
          <div class="d-flex mb-5">
            <div>
              <select
                id="jenis_permohonan"
                v-model="jenis_permohonan"
                class="form-control"
              >
                <option value="Berusaha">Berusaha</option>
                <option value="Non Berusaha">Non Berusaha</option>
              </select>
            </div>
            <div class="d-flex flex-grow-1 ml-2">
              <input
                id="no_permohonan"
                v-model="no_permohonan"
                type="text"
                class="form-control"
                placeholder="Contoh: I-123456/20.XX.X"
              />
              <button
                style="width: 200px"
                type="button"
                class="btn btn-primary ml-2 text-nowrap"
                @click="getTracking"
              >
                Cari Permohonan
              </button>
            </div>
          </div>
          <div v-if="is_exist === true">
            <div
              v-for="(data, index) in dataTracking"
              :key="index"
              :class="[
                'tracking-container',
                {
                  active: data.active && index + 1 !== dataTracking.length,
                  finished: data.accomplished
                }
              ]"
            >
              <div class="position-relative">
                <div class="tracking-bullet">
                  <svg
                    v-if="
                      index + 1 !== dataTracking.length
                        ? data.accomplished && !data.active
                        : data.accomplished
                    "
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.5 10.75L8.5 16.75L17.5 3.25"
                      stroke="white"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div class="tracking-item">
                  <p class="tracking-title">
                    {{ data.status }}
                  </p>
                  <small
                    v-if="data.catatan"
                    class="text-danger"
                  >
                    {{ data.catatan }}
                  </small>
                  <p v-if="data.timeStamp">
                    {{ formatDate(data.timeStamp, 'HH:mm, DD MMMM YYYY') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div v-if="is_exist === false">Nomor permohonan tidak ditemukan</div>
          <div
            v-if="is_error"
            class="text-danger"
          >
            Terjadi kesalahan saat mengambil data
          </div>
        </div>
      </section>
    </div>
    <site-footer :show-subscribe="true" />
    <copyright />
  </div>
</template>

<script>
import NavBar from '../views/commons/NavBar'
import PageHeader from '../views/commons/PageHeader'
import SiteFooter from '../views/commons/SiteFooter'
import Copyright from '../views/commons/Copyright'

import dayjs from 'dayjs'
import 'dayjs/locale/id'

export default {
  name: 'GalleryPage',
  components: {
    SiteFooter,
    PageHeader,
    NavBar,
    Copyright
  },
  data() {
    return {
      // apiEsea: 'https://be.sea-v3.mysurvey.id/api',
      apiEsea: 'https://backend-sea.kkp.go.id/api',
      jenis_permohonan: 'Berusaha',
      no_permohonan: '',
      is_exist: null,
      is_error: false,
      dataTracking: []
    }
  },
  methods: {
    dayjs,
    formatDate(date, format) {
      return dayjs(date).locale('id').format(format)
    },

    async getTracking() {
      this.is_exist = null
      this.is_error = false
      try {
        const res =
          this.jenis_permohonan === 'Berusaha'
            ? await this.$axios.get(
                `${this.apiEsea}/permohonan/dataTable?filter=nomor_permohonan,=,${this.no_permohonan}`
              )
            : await this.$axios.get(
                `${this.apiEsea}/permohonan_nonberusaha/dataTable?filter=nomor_permohonan,=,${this.no_permohonan}`
              )

        if (res.data.data.length === 0) {
          this.is_exist = false
          return
        }
        this.is_exist = true

        const resTracking = await this.$axios.get(
          `${this.apiEsea}/dashboard/trackingStatusPermohonan?jenis_permohonan=${this.jenis_permohonan}&no_permohonan=${this.no_permohonan}`
        )

        const activeIndex = resTracking.data.data.findLastIndex(
          (d) => d.accomplished
        )
        this.dataTracking = resTracking.data.data.map((d, i) => {
          return {
            ...d,
            active: activeIndex === i
          }
        })
      } catch (error) {
        this.is_error = true
      }
    }
  }
}
</script>